<app-loader *ngIf="isDisabled || isGrouping"></app-loader>
<div class="p-2">
    <div class="row gx-3 gy-2 mb-2" style="justify-content:right">
        <div class="col"></div>
        <div class="col-md-3" *ngIf="mfilter.filterType == 1">
            <ngb-datepicker #dp [(ngModel)]="mfilter.FromDate" class="month-year"
                (navigate)="mfilter.FromDate= $event.next;onNavigate($event)"></ngb-datepicker>
        </div>
        <div class="col-md-2" *ngIf="mfilter.filterType == 2">
            <div class="input-group">
                <input class="form-control" placeholder="dd-mm-yyyy" name="FromDateRange" [(ngModel)]="mfilter.FromDate"
                    ngbDatepicker #FromDate="ngbDatepicker" />
                <button class="btn btn-outline-secondary bi bi-calendar3" (click)="FromDate.toggle()"
                    type="button"></button>
            </div>
        </div>
        <div class="col-md-2" *ngIf="mfilter.filterType == 2 || mfilter.filterType == 4">
            <div class="input-group">
                <input class="form-control" placeholder="dd-mm-yyyy" name="ToDateRange" [(ngModel)]="mfilter.ToDate"
                    ngbDatepicker #ToDate="ngbDatepicker" />
                <button class="btn btn-outline-secondary bi bi-calendar3" (click)="ToDate.toggle()"
                    type="button"></button>
            </div>
        </div>
        <div class="col-md-2">
            <select class="form-select" aria-label="filterType" placeholder="filterType" title="filterType"
                name="filterType" [(ngModel)]="mfilter.filterType" #filterType="ngModel" required>
                <option value='3'>Yesterday</option>
                <option value='0'>Today</option>
                <option value='1'>Monthly</option>
                <option value='4'>Date</option>
                <option value='2'>DateRange</option>
            </select>
        </div>
        <div class="col-auto">
            <button type="button" class="btn btn-outline-primary" [disabled]="isDisabled" (click)="FetchData()">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Fetch Data':'Loading...'}}</button>
        </div>
    </div>
</div>

<div class="card border-radius-0 mt-1 p-0">
    <div class="card-header">
        Dashboard - Back Office
    </div>
    <div class="card-body m-1 overflow-auto">
        <div class="p-2">
            <div class="row gx-3 gy-2 mb-2">
                <div class="col-md-3">
                    <ng-select [items]="Shifts" [multiple]="true" bindLabel="ShiftTitle" bindValue="ShiftMasterID"
                        placeholder="All Shift" [closeOnSelect]="false" [(ngModel)]="mfilter.ShiftMasterID">
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                            <input id="item-{{index}}" name="item-{{index}}" type="checkbox" [ngModel]="item$.selected"
                                [ngModelOptions]="{ standalone : true }" />
                            {{item.ShiftTitle}}
                        </ng-template>
                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of items.slice(0,1)">
                                <span class="ng-value-label">{{item.ShiftTitle}}</span>
                            </div>
                            <div class="ng-value" *ngIf="items.length > 1">
                                <span class="ng-value-label">{{items.length - 1}} more...</span>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
                <div class="col-md-3">
                    <ng-select [items]="States" [multiple]="true" bindLabel="StateName" bindValue="StateMasterID"
                        placeholder="All State" [closeOnSelect]="false" [(ngModel)]="mfilter.StateMasterID">
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                            <input id="item-{{index}}" name="item-{{index}}" type="checkbox" [ngModel]="item$.selected"
                                [ngModelOptions]="{ standalone : true }" />
                            {{item.StateName}}
                        </ng-template>
                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of items.slice(0,1)">
                                <span class="ng-value-label">{{item.StateName}}</span>
                            </div>
                            <div class="ng-value" *ngIf="items.length > 1">
                                <span class="ng-value-label">{{items.length - 1}} more...</span>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
                <div class="col-md-3">
                    <ng-select [items]="Regions" [multiple]="true" bindLabel="RegionName" bindValue="RegionMasterID"
                        placeholder="All Region" [closeOnSelect]="false" [(ngModel)]="mfilter.RegionMasterID">
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                            <input id="item-{{index}}" name="item-{{index}}" type="checkbox" [ngModel]="item$.selected"
                                [ngModelOptions]="{ standalone : true }" />
                            {{item.RegionName}}
                        </ng-template>
                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of items.slice(0,1)">
                                <span class="ng-value-label">{{item.RegionName}}</span>
                            </div>
                            <div class="ng-value" *ngIf="items.length > 1">
                                <span class="ng-value-label">{{items.length - 1}} more...</span>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
                <div class="col-md-3">
                    <ng-select [items]="Branchs" [multiple]="true" bindLabel="BranchName" bindValue="BranchMasterID"
                        placeholder="All Branch" [closeOnSelect]="false" [(ngModel)]="mfilter.BranchMasterID">
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                            <input id="item-{{index}}" name="item-{{index}}" type="checkbox" [ngModel]="item$.selected"
                                [ngModelOptions]="{ standalone : true }" />
                            {{item.BranchName}}
                        </ng-template>
                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of items.slice(0,1)">
                                <span class="ng-value-label">{{item.BranchName}}</span>
                            </div>
                            <div class="ng-value" *ngIf="items.length > 1">
                                <span class="ng-value-label">{{items.length - 1}} more...</span>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
            </div>
            <div class="row gx-3 gy-2 mb-2">
                <div class="col-md-3">
                    <ng-select [items]="Departments" [multiple]="true" bindLabel="DepartmentName"
                        bindValue="DepartmentID" placeholder="All Department" [closeOnSelect]="false"
                        [(ngModel)]="mfilter.DepartmentID">
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                            <input id="item-{{index}}" name="item-{{index}}" type="checkbox" [ngModel]="item$.selected"
                                [ngModelOptions]="{ standalone : true }" />
                            {{item.DepartmentName}}
                        </ng-template>
                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of items.slice(0,1)">
                                <span class="ng-value-label">{{item.DepartmentName}}</span>
                            </div>
                            <div class="ng-value" *ngIf="items.length > 1">
                                <span class="ng-value-label">{{items.length - 1}} more...</span>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
                <div class="col-md-3">
                    <ng-select [items]="Designations" [multiple]="true" bindLabel="DesignationName"
                        bindValue="DesignationID" placeholder="All Designation" [closeOnSelect]="false"
                        [(ngModel)]="mfilter.DesignationID">
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                            <input id="item-{{index}}" name="item-{{index}}" type="checkbox" [ngModel]="item$.selected"
                                [ngModelOptions]="{ standalone : true }" />
                            {{item.DesignationName}}
                        </ng-template>
                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                            <div class="ng-value" *ngFor="let item of items.slice(0,1)">
                                <span class="ng-value-label">{{item.DesignationName}}</span>
                            </div>
                            <div class="ng-value" *ngIf="items.length > 1">
                                <span class="ng-value-label">{{items.length - 1}} more...</span>
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
                <div class="col"></div>
                <div class="col-auto">
                    <button class="btn btn-primary" type="button" (click)="FilterFormBack()"
                        [disabled]="isDisabled || isApply"><i class="bi bi-funnel me-2" *ngIf="!isApply"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isApply"></span>
                        {{!isApply?'Apply':'Applying...'}}
                    </button>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <div class="tile m-1 cursor-pointer" (click)="CardCountFilter('total')">
                        <div class="row" style="line-height: 30px;">
                            <div class="col-3 p-3 m-0 text-center" style="background-color: #0078D4;color: #fff;">
                                <i class="bi bi-people fs-1"></i>
                            </div>
                            <div class="col-9 text-end p-0 m-0" style="background-color: #EBF3FE;color: #0078D4;">
                                <div class="m-1" style="font-size:medium; font-weight: 500;">
                                    Total
                                </div>
                                <div class="m-1 count" style="font-size: xx-large;font-weight:400;line-height: 32px;">
                                    {{Card.Total}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="tile m-1 cursor-pointer" (click)="CardCountFilter('present')">
                        <div class="row" style="line-height: 34px;">
                            <div class="col-3 p-3 m-0 text-center" style="background-color: #00d68f;color: #fff;">
                                <i class="bi bi-person-check fs-1"></i>
                            </div>
                            <div class="col-9 text-end p-0 m-0" style="background-color: #E6FFFA;color: #00d68f;">
                                <div class="m-1" style="font-size:medium; font-weight: 500;">
                                    <div class="row">
                                        <div class="col-auto" style="font-size:large; font-weight: 400;"><span
                                                class="badge success"
                                                style="background-color: #00d68f;">{{Card.PresentPer}}%</span></div>
                                        <div class="col">Present</div>
                                    </div>
                                </div>
                                <div class="m-1 count" style="font-size: xx-large;font-weight:400">
                                    {{Card.Present}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="tile m-1 cursor-pointer" (click)="CardCountFilter('absent')">
                        <div class="row" style="line-height: 34px;">
                            <div class="col-3 p-3 m-0 text-center" style="background-color: #FF0000;color: #fff;">
                                <i class="bi bi-person-x fs-1"></i>
                            </div>
                            <div class="col-9 text-end p-0 m-0" style="background-color: #FBF2EF;color: #FF0000;">
                                <div class="m-1" style="font-size:medium; font-weight: 500;">
                                    <div class="row">
                                        <div class="col-auto" style="font-size:large; font-weight: 400;"><span
                                                class="badge danger"
                                                style="background-color: #FF0000;">{{Card.AbsentPer}}%</span></div>
                                        <div class="col">Absent</div>
                                    </div>
                                </div>
                                <div class="m-1 count" style="font-size: xx-large;font-weight:400">
                                    {{Card.Absent}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="tile m-1 cursor-pointer" (click)="CardCountFilter('weeklyoff')">
                        <div class="row" style="line-height: 30px;">
                            <div class="col-3 p-3 m-0 text-center" style="background-color: #6A0DAD;color: #fff;">
                                <i class="bi bi-calendar2-week fs-1"></i>
                            </div>
                            <div class="col-9 text-end p-0 m-0" style="background-color: #c999eb;color: #6A0DAD;">
                                <div class="m-1" style="font-size:medium; font-weight: 500;">
                                    Weekoff
                                </div>
                                <div class="m-1 count" style="font-size: xx-large;font-weight:400;line-height: 32px;">
                                    {{Card.WeeklyOff}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="tile m-1 cursor-pointer" (click)="CardCountFilter('leave')">
                        <div class="row" style="line-height: 30px;">
                            <div class="col-3 p-3 m-0 text-center" style="background-color: #ffcc00;color: #fff;">
                                <i class="bi bi-cup-hot fs-1"></i>
                            </div>
                            <div class="col-9 text-end p-0 m-0" style="background-color: #f8edc1;color: #ffcc00;">
                                <div class="m-1" style="font-size:medium; font-weight: 500;">
                                    Leave
                                </div>
                                <div class="m-1 count" style="font-size: xx-large;font-weight:400;line-height: 32px;">
                                    {{Card.Leave}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="tile m-1 cursor-pointer" (click)="CardCountFilter('holiday')">
                        <div class="row" style="line-height: 30px;">
                            <div class="col-3 p-3 m-0 text-center" style="background-color: #0096FF;color: #fff;">
                                <i class="bi bi-binoculars fs-1"></i>
                            </div>
                            <div class="col-9 text-end p-0 m-0" style="background-color: #c8e2f5;color: #0096FF;">
                                <div class="m-1" style="font-size:medium; font-weight: 500;">
                                    Holiday
                                </div>
                                <div class="m-1 count" style="font-size: xx-large;font-weight:400;line-height: 32px;">
                                    {{Card.Holiday}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card border-radius-0 m-1 p-0">
            <div class="card-header">
                <div class="row">
                    <div class="col">Attendance</div>
                    <div class="col-auto">
                        <div class="form-check form-switch"
                            (click)="Collapsed.AttendanceGraph = !Collapsed.AttendanceGraph">
                            <input class="form-check-input toggle" type="checkbox" role="switch"
                                [ngModel]="Collapsed.AttendanceGraph" (change)="$event.preventDefault();">
                            <label class="form-check-label"
                                [ngClass]="{'toggle-on':Collapsed.AttendanceGraph,'toggle-off':!Collapsed.AttendanceGraph}"
                                for="flexSwitchCheckDefault">{{Collapsed.AttendanceGraph?'ON':'OFF'}}</label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-body m-1 overflow-auto" #collapse="ngbCollapse"
                [(ngbCollapse)]="!Collapsed.AttendanceGraph">
                <div class="chart-scroll-container">
                    <div class="chart-container">
                        <canvas baseChart [type]="'bar'" [data]="AttendanceChartData"
                            [options]="{responsive: true,maintainAspectRatio: false,scales: {x: {ticks: {maxRotation: 45,minRotation: 45,font: {size: 10}}},y: {ticks: {font: {size: 10}}}}}"
                            [legend]="ChartLegend.Attendance">
                        </canvas>
                    </div>
                </div>
            </div>
        </div>
        <div class="card border-radius-0 m-1 p-0">
            <div class="card-header">
                <div class="row">
                    <div class="col">Branch</div>
                    <div class="col-auto">
                        <div class="form-check form-switch" (click)="Collapsed.BranchGraph = !Collapsed.BranchGraph">
                            <input class="form-check-input toggle" type="checkbox" role="switch"
                                [ngModel]="Collapsed.BranchGraph" (change)="$event.preventDefault();">
                            <label class="form-check-label"
                                [ngClass]="{'toggle-on':Collapsed.BranchGraph,'toggle-off':!Collapsed.BranchGraph}"
                                for="flexSwitchCheckDefault">{{Collapsed.BranchGraph?'ON':'OFF'}}</label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-body m-1 overflow-auto" #collapse="ngbCollapse" [(ngbCollapse)]="!Collapsed.BranchGraph">
                <div class="chart-scroll-container">
                    <div class="chart-container">
                        <canvas baseChart [type]="'bar'" [data]="BranchChartData"
                            [options]="{responsive: true,maintainAspectRatio: false,scales: {x: {stacked: true,ticks: {maxRotation: 45,minRotation: 45,font: {size: 10}}},y: {stacked: true,ticks: {font: {size: 10}}}}}"
                            [legend]="ChartLegend.Branch">
                        </canvas>
                    </div>
                </div>
            </div>
        </div>
        <div class="card border-radius-0 m-1 p-0">
            <div class="card-header">
                <div class="row">
                    <div class="col">Analytics</div>
                    <div class="col-auto"><button type="button" class="btn btn-primary btn-sm" [disabled]="isDisabled"
                            (click)="ExcelDump(0)">
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                *ngIf="isDisabled"></span>
                            <i *ngIf="!isDisabled" class="bi bi-file-earmark-spreadsheet-fill"></i>
                            {{!isDisabled?'Excel':'Loading...'}}</button>
                    </div>
                    <div class="col-auto">
                        <div ngbDropdown class="d-inline-block" #groupDrop="ngbDropdown">
                            <button type="button" class="btn btn-outline-primary btn-sm" id="dropdownForm1"
                                ngbDropdownToggle [disabled]="isDisabled || isGrouping">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isGrouping"></span>Grouping
                            </button>
                            <div ngbDropdownMenu aria-labelledby="dropdownForm1" display="dynamic">
                                <form class="px-4 py-3" (submit)="showGroupBack()">
                                    <label class="Label">
                                        <input type="checkbox" name="groupCheckall" (change)="CheckAllGroupBy()"
                                            [(ngModel)]="groupby.Checkall" ngbCheckbox />
                                        Select All
                                    </label><br />
                                    <label class="Label">
                                        <input type="checkbox" name="groupState" [(ngModel)]="groupby.State"
                                            ngbCheckbox />
                                        State
                                    </label><br />
                                    <label class="Label">
                                        <input type="checkbox" name="groupRegion" [(ngModel)]="groupby.Region"
                                            ngbCheckbox />
                                        Region
                                    </label><br />
                                    <label class="Label">
                                        <input type="checkbox" name="groupBranch" [(ngModel)]="groupby.Branch"
                                            ngbCheckbox /> Branch
                                    </label>
                                    <label class="Label">
                                        <input type="checkbox" name="groupDepartment" [(ngModel)]="groupby.Department"
                                            ngbCheckbox /> Department
                                    </label>
                                    <label class="Label">
                                        <input type="checkbox" name="groupDesignation" [(ngModel)]="groupby.Designation"
                                            ngbCheckbox /> Designation
                                    </label>
                                    <div class="dropdown-divider"></div>
                                    <button type="submit" (click)="groupDrop.close();"
                                        class="btn btn-outline-primary btn-sm">Apply</button>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div class="col-auto">
                        <div class="form-check form-switch"
                            (click)="Collapsed.AttendanceAnalytics = !Collapsed.AttendanceAnalytics">
                            <input class="form-check-input toggle" type="checkbox" role="switch"
                                [ngModel]="Collapsed.AttendanceAnalytics" (change)="$event.preventDefault();">
                            <label class="form-check-label"
                                [ngClass]="{'toggle-on':Collapsed.AttendanceAnalytics,'toggle-off':!Collapsed.AttendanceAnalytics}"
                                for="flexSwitchCheckDefault">{{Collapsed.AttendanceAnalytics?'ON':'OFF'}}</label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-body m-1 overflow-auto" #collapse="ngbCollapse"
                [(ngbCollapse)]="!Collapsed.AttendanceAnalytics">
                <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" id="summarydata"
                    class="customeDatatable table table-bordered" name="summarydata">
                    <thead class="table-light">
                        <tr>
                            <th scope="col" style="width: 5px;">#</th>
                            <th style="width: 200px;">BranchManpower</th>
                            <th style="width: 200px;">Present</th>
                            <th style="width: 200px;">Weekoff</th>
                            <th style="width: 200px;">Leave</th>
                            <th style="width: 200px;">Holiday</th>
                            <th style="width: 200px;">Absent</th>
                            <th style="width: 200px;">Absent%</th>
                            <th [ngClass]="{'colHide': !groupby.State}" style="width: 500px;">State Name</th>
                            <th [ngClass]="{'colHide': !groupby.Region}" style="width: 500px;">Region Name</th>
                            <th [ngClass]="{'colHide': !groupby.Branch}">Branch Name</th>
                            <th [ngClass]="{'colHide': !groupby.Department}">Department Name</th>
                            <th [ngClass]="{'colHide': !groupby.Designation}">Designation Name</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let TableData of filterData; let i = index">
                            <th scope="row" style="width: 5px;">{{i+1}}</th>
                            <td class="text-end">{{Sitemanpower(TableData)}}</td>
                            <td class="text-end">{{Present(TableData)}}</td>
                            <td class="text-end">{{Weekoff(TableData)}}</td>
                            <td class="text-end">{{Leave(TableData)}}</td>
                            <td class="text-end">{{Holiday(TableData)}}</td>
                            <td class="text-end">{{Absent(TableData)}}</td>
                            <td class="text-end">{{AbsentPer(TableData).toFixed(2)}}%</td>
                            <td [ngClass]="{'colHide': !groupby.State}" style="width: 500px;"
                                class="text-primary cursor-pointer"
                                (click)="EmpTableFilter('State',TableData[0]['StateMasterId'])">
                                {{groupby.State?TableData[0]['StateName']:''}}</td>
                            <td [ngClass]="{'colHide': !groupby.Region}" style="width: 500px;"
                                class="text-primary cursor-pointer"
                                (click)="EmpTableFilter('Region',TableData[0]['RegionMasterID'])">
                                {{groupby.Region?TableData[0]['RegionName']:''}}</td>
                            <td [ngClass]="{'colHide': !groupby.Branch}" class="text-primary cursor-pointer"
                                (click)="EmpTableFilter('Branch',TableData[0]['BranchMasterID'])">
                                {{groupby.Branch?TableData[0]['BranchName']:''}}
                            <td [ngClass]="{'colHide': !groupby.Department}" class="text-primary cursor-pointer"
                                (click)="EmpTableFilter('Department',TableData[0]['DepartmentMasterID'])">
                                {{groupby.Department?TableData[0]['DepartmentName']:''}}
                            </td>
                            <td [ngClass]="{'colHide': !groupby.Designation}" class="text-primary cursor-pointer"
                                (click)="EmpTableFilter('Designation',TableData[0]['DesignationMasterID'])">
                                {{groupby.Designation?TableData[0]['DesignationName']:''}}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="card border-radius-0 m-1 p-0">
            <div class="card-header">
                <div class="row">
                    <div class="col">Employee Details</div>
                    <div class="col-auto">
                        <button *ngIf="filterEmpData.length > 0" type="button" class="btn btn-primary btn-sm"
                            [disabled]="isDisabled" (click)="ExcelDump(1)">
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                *ngIf="isDisabled"></span>
                            <i *ngIf="!isDisabled" class="bi bi-file-earmark-spreadsheet-fill"></i>
                            {{!isDisabled?'Excel':'Loading...'}}</button>

                        <button *ngIf="!this.mfilter.EmpDataLoad" type="button" class="btn btn-primary btn-sm"
                            [disabled]="isDisabled">
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            Fetching...</button>
                    </div>
                    <div class="col-auto">
                        <div class="form-check form-switch"
                            (click)="Collapsed.EmployeeDetails = !Collapsed.EmployeeDetails">
                            <input class="form-check-input toggle" type="checkbox" role="switch"
                                [ngModel]="Collapsed.EmployeeDetails" (change)="$event.preventDefault();">
                            <label class="form-check-label"
                                [ngClass]="{'toggle-on':Collapsed.EmployeeDetails,'toggle-off':!Collapsed.EmployeeDetails}"
                                for="flexSwitchCheckDefault">{{Collapsed.EmployeeDetails?'ON':'OFF'}}</label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-body m-1 overflow-auto" #collapse="ngbCollapse"
                [(ngbCollapse)]="!Collapsed.EmployeeDetails">
                <table datatable [dtOptions]="dtOptionsEmp" [dtTrigger]="dtTriggerEmp" id="empdatatable"
                    class="customeDatatable table table-bordered" name="empdatatable">
                    <thead class="table-light">
                        <tr>
                            <th scope="col" style="width: 5px;">#</th>
                            <th>Details</th>
                            <th>Department Name</th>
                            <th>Shift Name</th>
                            <th>AttendanceDate</th>
                            <th>InTime</th>
                            <th>OutTime</th>
                            <th>State Name</th>
                            <th>Branch Name</th>
                            <th>Attendance</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let TableDataEmp of filterEmpData; let i = index">
                            <th scope="row" style="width: 5px;">{{i+1}}</th>
                            <td>
                                <div class="row no-gutters cursor-pointer" style="align-items: center;width: 300px;">
                                    <div class="col-2">
                                        <img *ngIf="TableDataEmp['EmpPhoto'] != null && TableDataEmp['EmpPhoto'] != ''"
                                            (click)="common.FullImage('',{ProfileImage:common.PhotoLink(TableDataEmp['EmpPhoto']),Name:TableDataEmp['FullName'],Code:TableDataEmp['EmpCode'],Designation:TableDataEmp['DesignationName'],ContactNo:TableDataEmp['ContactNo']} )"
                                            mat-card-image class="userImage"
                                            [src]="common.PhotoLink(TableDataEmp['EmpPhoto'])" />
                                        <div *ngIf="TableDataEmp['EmpPhoto'] == null || TableDataEmp['EmpPhoto'] == ''"
                                            (click)="common.FullImage('',{ProfileImage:common.PhotoLink(TableDataEmp['EmpPhoto']),Name:TableDataEmp['FullName'],Code:TableDataEmp['EmpCode'],Designation:TableDataEmp['DesignationName'],ContactNo:TableDataEmp['ContactNo']} )"
                                            class="initial-image">
                                            <div class="image">
                                                {{common.getInitial(TableDataEmp['FullName'])}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class=" col-9 userdetail">
                                        <span class="text-label">{{TableDataEmp['FullName']}}</span><br />
                                        <span class="text-label-light">#{{TableDataEmp['EmpCode']}}</span><br />
                                        <span class="text-label-light">{{TableDataEmp['DesignationName']}}</span>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div style="width: 100px;">{{TableDataEmp['DepartmentName']}}</div>
                            </td>
                            <td>{{TableDataEmp['ShiftTitle']}}</td>
                            <td>{{TableDataEmp['AttendanceDate'] | date: 'dd MMM, yyyy'}}</td>
                            <td>{{TableDataEmp['InTime'] | date : 'H:mm:ss'}} <br />
                                <img *ngIf="TableDataEmp['DailyAttendancePhotoIn'] != null && TableDataEmp['DailyAttendancePhotoIn'] != ''"
                                    (click)="common.FullImage(common.PhotoLink(TableDataEmp['DailyAttendancePhotoIn'],true),{ProfileImage :common.PhotoLink(TableDataEmp['EmpPhoto']), Name:TableDataEmp['FullName'],Code:TableDataEmp['EmpCode'],Designation:TableDataEmp['DesignationName'],ContactNo:TableDataEmp['ContactNo'], MTitle1:'In Date', MTitle2:'In Time',MData1: TableDataEmp['InTime'], MData2:TableDataEmp['InTime'],Address : TableDataEmp['CheckInAddress'], IsAttendanceMatch : TableDataEmp['IsInAttendanceMatch'], AttendanceMatchPercentage : TableDataEmp['AttendanceMatchPercentage'], Latitude : TableDataEmp['Latitude'], Longitude : TableDataEmp['Longitude']})"
                                    mat-card-image class="userImage"
                                    [src]="common.PhotoLink(TableDataEmp['DailyAttendancePhotoIn'],true)" />
                                <div *ngIf="TableDataEmp['DailyAttendancePhotoIn'] == null || TableDataEmp['DailyAttendancePhotoIn'] == ''"
                                    (click)="common.FullImage(common.PhotoLink(TableDataEmp['DailyAttendancePhotoIn'],true),{ProfileImage :common.PhotoLink(TableDataEmp['EmpPhoto']), Name:TableDataEmp['FullName'],Code:TableDataEmp['EmpCode'],Designation:TableDataEmp['DesignationName'],ContactNo:TableDataEmp['ContactNo'], MTitle1:'In Date', MTitle2:'In Time',MData1: TableDataEmp['InTime'], MData2:TableDataEmp['InTime'],Address : TableDataEmp['CheckInAddress'], IsAttendanceMatch : TableDataEmp['IsInAttendanceMatch'], AttendanceMatchPercentage : TableDataEmp['AttendanceMatchPercentage'], Latitude : TableDataEmp['Latitude'], Longitude : TableDataEmp['Longitude']})"
                                    class="initial-image">
                                    <div class="image">
                                        {{common.getInitial(TableDataEmp['FullName'])}}
                                    </div>
                                </div>
                            </td>
                            <td>{{TableDataEmp['OutTime'] | date : 'H:mm:ss'}} <br />
                                <img *ngIf="TableDataEmp['DailyAttendancePhotoOut'] != null && TableDataEmp['DailyAttendancePhotoOut'] != ''"
                                    (click)="common.FullImage(common.PhotoLink(TableDataEmp['DailyAttendancePhotoOut'],true),{ProfileImage :common.PhotoLink(TableDataEmp['EmpPhoto']), Name:TableDataEmp['FullName'],Code:TableDataEmp['EmpCode'],Designation:TableDataEmp['DesignationName'],ContactNo:TableDataEmp['ContactNo'], MTitle1:'Out Date', MTitle2:'Out Time',MData1: TableDataEmp['OutTime'], MData2:TableDataEmp['OutTime'],Address : TableDataEmp['CheckOutAddress'], IsAttendanceMatch : TableDataEmp['IsOutAttendanceMatch'], AttendanceMatchPercentage : TableDataEmp['OutAttendanceMatchPercentage'], Latitude : TableDataEmp['LatitudeOut'], Longitude : TableDataEmp['LongitudeOut']})"
                                    mat-card-image class="userImage"
                                    [src]="common.PhotoLink(TableDataEmp['DailyAttendancePhotoOut'],true)" />
                                <div *ngIf="TableDataEmp['DailyAttendancePhotoOut'] == null || TableDataEmp['DailyAttendancePhotoOut'] == ''"
                                    (click)="common.FullImage(common.PhotoLink(TableDataEmp['DailyAttendancePhotoOut'],true),{ProfileImage :common.PhotoLink(TableDataEmp['EmpPhoto']), Name:TableDataEmp['FullName'],Code:TableDataEmp['EmpCode'],Designation:TableDataEmp['DesignationName'],ContactNo:TableDataEmp['ContactNo'], MTitle1:'Out Date', MTitle2:'Out Time',MData1: TableDataEmp['OutTime'], MData2:TableDataEmp['OutTime'],Address : TableDataEmp['CheckOutAddress'], IsAttendanceMatch : TableDataEmp['IsOutAttendanceMatch'], AttendanceMatchPercentage : TableDataEmp['OutAttendanceMatchPercentage'], Latitude : TableDataEmp['LatitudeOut'], Longitude : TableDataEmp['LongitudeOut']})"
                                    class="initial-image">
                                    <div class="image">
                                        {{common.getInitial(TableDataEmp['FullName'])}}
                                    </div>
                                </div>
                            </td>
                            <td>{{TableDataEmp['StateName']}}</td>
                            <td>{{TableDataEmp['BranchName']}}</td>
                            <td>{{TableDataEmp['AttendanceRemark']}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>